export { default as PersistentAnnouncementBar } from './PersistentAnnouncementBar'
export type { PersistentAnnouncementBarProps } from './PersistentAnnouncementBar'
